// ============================================
// 八字分析页面 - 包含大运流年流月流日流时
// ============================================

import { Box, Stack, Typography } from "@mui/material";
import BaZiBase from "./BaZiBase";
import DaYunLiuNian from "./DaYunLiuNian";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import PersonBaseInfo from "./PersonInfoOutput";
import { useState, useEffect } from "react";
import { utcStr2Show, beijingIsoStr2Show } from "../StyleControl";
import { fetchJieQiDates, getLunarMonthByDate, getCurrentTimeSelection } from "../../utils/baziCalculator";

// 启用 UTC 和时区插件
dayjs.extend(utc);
dayjs.extend(timezone);
// 固定使用北京时间
dayjs.tz.setDefault("Asia/Shanghai");

export default function BaZiFenXiPage({ data, onSwitchToAiZhiLing }) {
  const [currentDaYun, setCurrentDaYun] = useState();
  const [currentLiuNian, setCurrentLiuNian] = useState();
  const [currentLiuYue, setCurrentLiuYue] = useState();
  const [currentLiuRi, setCurrentLiuRi] = useState();
  const [currentLiuShi, setCurrentLiuShi] = useState();

  // 初始化时根据当前时间设置选中状态
  useEffect(() => {
    if (data) {
      const now = new Date();
      const selection = getCurrentTimeSelection(data, now);
      setCurrentDaYun(selection.currentDaYun);
      setCurrentLiuNian(selection.currentLiuNian);
      setCurrentLiuShi(selection.currentLiuShi);

      // 异步获取节气数据，计算正确的农历月份
      if (selection.currentLiuNian) {
        fetchJieQiDates(selection.currentLiuNian).then((jieQiData) => {
          if (selection.isInDaYunRange) {
            // 在大运范围内，使用当前日期计算
            const { lunarMonth, dayKey } = getLunarMonthByDate(now, jieQiData);
            setCurrentLiuYue(lunarMonth);
            setCurrentLiuRi(dayKey);
          } else {
            // 不在大运范围内，默认选中第一个流月的第一个流日
            // 正月（寅月）从立春开始
            const liChunUtc = jieQiData["立春"];
            if (liChunUtc) {
              const liChunDate = new Date(liChunUtc);
              // 转为北京时间
              const bjDate = new Date(liChunDate.getTime() + 8 * 60 * 60 * 1000);
              setCurrentLiuYue(1); // 正月
              setCurrentLiuRi(`${bjDate.getMonth() + 1}月${bjDate.getDate()}日`);
            } else {
              setCurrentLiuYue(1);
              setCurrentLiuRi(null);
            }
          }
        });
      } else {
        setCurrentLiuYue(selection.currentLiuYue);
        setCurrentLiuRi(selection.currentLiuRi);
      }
    }
  }, [data]);

  if (!data) {
    return <Typography>请先进行排盘</Typography>;
  }

  const name = data.name;
  const qiYunStr = data.qiyun_str;
  const birthday = dayjs.utc(data.birthday_str).tz("Asia/Shanghai");
  const birthYear = birthday.year();
  const birthShow = utcStr2Show(data.birthday_str);

  const riGan = data.ri_gan;
  const daYunStartYear = data.da_yun_start_year;
  const daYun = data.da_yun;

  const trueSolarTime = data.true_solar_time
    ? beijingIsoStr2Show(data.true_solar_time)
    : null;

  const personInfoProp = {
    name,
    birthShow,
    riGan,
    onExport: onSwitchToAiZhiLing,
    useTrueSolar: data.use_true_solar,
    birthplace: data.birthplace,
    longitude: data.longitude,
    trueSolarTime,
  };

  function daYunLiuNianChange(
    yunYear,
    liuYear,
    liuYue,
    liuRi,
    liuShi
  ) {
    setCurrentDaYun(yunYear);
    setCurrentLiuNian(liuYear);
    setCurrentLiuYue(liuYue);
    setCurrentLiuRi(liuRi);
    setCurrentLiuShi(liuShi);
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction={"column"} spacing={1} sx={{ width: "100%", px: 2, pt: 1 }}>
        <PersonBaseInfo {...personInfoProp}></PersonBaseInfo>
        <BaZiBase
          data={data}
          yunYear={currentDaYun}
          liuYear={currentLiuNian}
          liuYue={currentLiuYue}
          liuRi={currentLiuRi}
          liuShi={currentLiuShi}
        ></BaZiBase>
        <DaYunLiuNian
          birthYear={birthYear}
          daYunStartYear={daYunStartYear}
          daYun={daYun}
          qiYunStr={qiYunStr}
          riGan={riGan}
          currentDaYun={currentDaYun}
          currentLiuNian={currentLiuNian}
          currentLiuYue={currentLiuYue}
          currentLiuRi={currentLiuRi}
          currentLiuShi={currentLiuShi}
          onChange={daYunLiuNianChange}
        ></DaYunLiuNian>
      </Stack>
    </Box>
  );
}

export { PersonBaseInfo };
